import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import InviteCode from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.inviteCode,
    component: InviteCode,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
